<template>
  <div>
    <v-container fill-height fluid grid-list-xl>
      <v-layout wrap>
        <v-flex md6 sm12 lg4 v-for="(campaign, index) in campaignList" :key="index">
          <v-card style="min-height:170px" color="#363636" dark>
            <v-card-title style="font-size: 23px;">{{campaign.name}}</v-card-title>
            <v-card-text class="pt-5">
              <div class="text-right">
                <v-btn :to="'/reports/campaign/summary?id='+campaign.id" target="_blank" color="warning" right>View HTML Report</v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-divider></v-divider>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="90"
      height.number="90"
    ></loading>
  </div>
</template>

<script>
import config from '../../../config';
import campaignAPIs from './campaignAPIs';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
  components: { Loading },
  data() {
    return {
      isLoading: false,
      campaignList: [] // List ongoing campaigns
    };
  },
  mounted() {
    this.fetchCampaignList();
  },
  methods: {
    fetchCampaignList() {
      this.isLoading = true
      campaignAPIs
        .getAllCampaigns(`${config.campaignStatus.ONGOING},${config.campaignStatus.REVIEW},${config.campaignStatus.COMPLETE}`, true) // In future, Campaign status could be change
        .then(response => {
          let results = [];
          response.data.campaigns.forEach(element => {
            let campaign = {
              name: element.name,
              id: element.id
            };
            results.push(campaign);
          });
          this.campaignList = results.sort((a, b) => {
            if (a.name > b.name) {
              return -1;
            }
            if (a.name < b.name) {
              return 1;
            }
            return 0;
          });
          this.isLoading = false
        })
        .catch(err => {
          console.log('Error:' + err);
          this.isLoading = false
        });
    }
  }
};
</script>
<style lang="scss">
.campaing-infor {
  background: #076585; /* fallback for old browsers */
  background: -webkit-linear-gradient(to bottom, #076585, #fff); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to bottom, #076585, #fff); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
.campaign-post {
  a:link,
  a:visited {
    color: white !important;
    background-color: transparent;
    text-decoration: none;
  }
}
.igPost-block {
  overflow: scroll;
  max-width: 350px;
  max-height: 350px;
}
</style>



// WEBPACK FOOTER //
// CampaignReport.vue?5c920db1